<script setup>
import { useI18n } from 'vue-i18n';
import ReportMetricCard from '../ReportMetricCard.vue';
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  returnLabels: {
    type: Number,
    default: 0,
  },
  totalRefunds: {
    type: Number,
    default: 0,
  },
  totalCancellations: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const formatCount = value => {
  if (!value && value !== 0) return '--';
  return value.toLocaleString();
};
</script>

<template>
  <div
    class="flex flex-col rounded-xl shadow outline-1 outline outline-n-container bg-n-solid-2 px-6 py-5"
  >
    <h3 class="mb-4 text-sm font-medium text-n-slate-11">
      {{ t('CEO_DASHBOARD.ACTIONS.HEADER') }}
    </h3>
    <div v-if="loading" class="flex items-center justify-center py-8">
      <Spinner />
    </div>
    <div v-else class="grid grid-cols-3 gap-6">
      <ReportMetricCard
        :label="t('CEO_DASHBOARD.ACTIONS.RETURN_LABELS')"
        :info-text="t('CEO_DASHBOARD.ACTIONS.RETURN_LABELS_TOOLTIP')"
        :value="formatCount(returnLabels)"
      />
      <ReportMetricCard
        :label="t('CEO_DASHBOARD.ACTIONS.REFUNDS')"
        :info-text="t('CEO_DASHBOARD.ACTIONS.REFUNDS_TOOLTIP')"
        :value="formatCount(totalRefunds)"
      />
      <ReportMetricCard
        :label="t('CEO_DASHBOARD.ACTIONS.CANCELLATIONS')"
        :info-text="t('CEO_DASHBOARD.ACTIONS.CANCELLATIONS_TOOLTIP')"
        :value="formatCount(totalCancellations)"
      />
    </div>
  </div>
</template>
